const dict = {
  'zh-Hant': {
    appName: '溫室控制',
    overview: '總覽',
    scene3d: '3D',
    env: '環境',
    actuators: '執行器',
    water: '水肥',
    cam: 'Cam 攝像頭',
    camHint: '獨立 NVR · App 只顯示畫面／警報聯動，唔做主錄影',
    camOffline: '未連線',
    camDemoTile: '示範鏡頭 · 未連線',
    camNone: '此棚未設定攝像頭',
    settings: '設定',
    demoBanner: '示範模式 · 未連線',
    houseStatus: '棚狀態',
    alerts: '警報',
    mode: '運行模式',
    controlMode: '控制',
    auto: '自動',
    manual: '人手保持',
    clear: '確認清除',
    locked: '已鎖定',
    houseJump: '跳去溫室編號…',
    addHouse: '新增溫室',
    addHousePrompt: '新溫室編號（例如 #4 或 l129）',
  },
  'zh-Hans': {
    appName: '温室控制',
    overview: '总览',
    scene3d: '3D',
    env: '环境',
    actuators: '执行器',
    water: '水肥',
    cam: 'Cam 摄像头',
    camHint: '独立 NVR · App 只显示画面／警报联动，不做主录像',
    camOffline: '未连线',
    camDemoTile: '示范镜头 · 未连线',
    camNone: '此棚未设定摄像头',
    settings: '设定',
    demoBanner: '示范模式 · 未连线',
    houseStatus: '棚状态',
    alerts: '警报',
    mode: '运行模式',
    controlMode: '控制',
    auto: '自动',
    manual: '人手保持',
    clear: '确认清除',
    locked: '已锁定',
    houseJump: '跳至温室编号…',
    addHouse: '新增温室',
    addHousePrompt: '新温室编号（例如 #4 或 l129）',
  },
  en: {
    appName: 'Greenhouse',
    overview: 'Overview',
    scene3d: '3D',
    env: 'Climate',
    actuators: 'Actuators',
    water: 'Water / Fert',
    cam: 'Cameras',
    camHint: 'Independent NVR · App shows view / alarm link only — not primary recording',
    camOffline: 'Offline',
    camDemoTile: 'Demo camera · Offline',
    camNone: 'No cameras on this house',
    settings: 'Settings',
    demoBanner: 'Demo mode · Offline',
    houseStatus: 'House status',
    alerts: 'Alarms',
    mode: 'Mode',
    controlMode: 'Control',
    auto: 'Auto',
    manual: 'Manual hold',
    clear: 'Ack / clear',
    locked: 'Locked',
    houseJump: 'Jump to house code…',
    addHouse: 'Add greenhouse',
    addHousePrompt: 'New house code (e.g. #4 or l129)',
  },
};

export function t(lang, key) {
  return (dict[lang] && dict[lang][key]) || dict['zh-Hant'][key] || key;
}
